import {BaseQueryApi} from "@reduxjs/toolkit/query";
import {useCallback, useState} from "react";
import {OtsAsyncThunkConfigExtra, OtsState} from "../store/ots-store";
import {removeUndefined} from "../util/util";
import {
  OnSiteTimeReportCriteria,
} from "../model/report/report";
import {buildStandardHeaders} from "../store/ots-api";

export type UseDownloadOnSiteTimeReportProps = {
  baseQueryApi: BaseQueryApi
}

export type UseDownloadOnSiteTimeReportResult = {
  downloadOnSiteTimeReport: (criteria: OnSiteTimeReportCriteria) => void
  report?: string
  error?: any
  loading: boolean
}

export const useDownloadOnSiteTimeReport = (props: UseDownloadOnSiteTimeReportProps): UseDownloadOnSiteTimeReportResult => {
  const {baseQueryApi} = props

  const [_report, _setReport] = useState<string | undefined>(undefined)
  const [_error, _setError] = useState()
  const [_loading, _setLoading] = useState<boolean>(false)

  const _downloadOnSiteTimeReport = useCallback((criteria: OnSiteTimeReportCriteria) => {

    _setReport(undefined)
    _setLoading(true)
    _setError(undefined)

    const headers = buildStandardHeaders(baseQueryApi)
    headers["Accept"] = 'application/json'
    headers["Content-Type"] = 'application/json'

    const request: RequestInit = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(criteria),
    }

    const baseUrl = (baseQueryApi.extra as OtsAsyncThunkConfigExtra).baseUrl;
    const url = `${baseUrl}/reports/on-site-time`;

    window.fetch(url, request)
      .then((response) => {
        response.text()
          .then((url) => {
            _setReport(url)
          })
          .catch((rejected) => {
            _setError(rejected)
            _setLoading(false)
          })
          .finally(() => {
            _setLoading(false)
          })
      })
      .catch((rejected) => {
        _setError(rejected)
        _setLoading(false)
      })
  }, [baseQueryApi])

  return {
    downloadOnSiteTimeReport: _downloadOnSiteTimeReport,
    report: _report,
    error: _error,
    loading: _loading,
  }
}
